import { Heading, Link, Modal, Stack, TextContainer } from "@shopify/polaris";
import { useEffect, useState } from "react";

const Release_21_20_01_Modal = (props: any) => {
  const [guideStep, setGuideStep] = useState(0);
  const [shop, setShop] = useState({ id: "", url: "" });

  useEffect(() => {
    let shop = JSON.parse(localStorage.getItem("shop") || "{}");
    if (shop && shop.id) {
      setShop(shop);
    }
  }, []);

  const modalContentGuideStep = () => {
    return (
      <TextContainer>
        <p className="release-heading ">
          <Heading>1. SuperLemon Prices Slashed</Heading>
        </p>
        <p>
          SuperLemon prices are <b>slashed!!!</b>
          <br />
          Ultimate plan is now for <b>$9.99/month</b>
          <br />
          and Pro plan is for <b>$7.99/month.</b>
          <br />
          <br />
          To avail this new price, please switch to the Free plan once and then
          back to the Pro or Ultimate plan for the new price plan to come into
          effect for your store.
        </p>
        <p className="release-heading ">
          <Heading>2. Templates Section Revamped</Heading>
        </p>
        <p>
          Templates section of SuperLemon is revamped to make it a one stop shop
          for all your templates. The new Templates section will have two new
          sub-sections : <b>Automated</b> and <b>Extension Templates</b>.
          <br />
          <br />
          The <b>Automated</b> (only for Ultimate plan users) sub-section will
          have all Automated Message Templates i.e. Abandon Cart Template, Order
          Confirmation, Order Shipment and Cash on Delivery Template in a new
          sub-section of Automated Messages as shown below:
        </p>
        <img
          className="checkoutOptinModalImage"
          src="https://cdn.shopify.com/s/files/1/0449/7794/6790/files/r-1.png?v=1639474202"
          alt="Automated Templates"
        />
        <p>
          The <b>Extension Templates</b> (only for Pro & Ultimate plan users)
          sub-section will have all Automated Message Templates i.e. Abandon
          Cart Template, Order Confirmation, Order Shipment and Cash on Delivery
          Template in a new sub-section of Automated Messages as shown below:
        </p>
        <img
          className="checkoutOptinModalImage"
          src="https://cdn.shopify.com/s/files/1/0449/7794/6790/files/r-updated.png?v=1639550236"
          alt="Extension Templates"
        />
        <p>
          To know more about the new features and functionalities please go
          through the guide of the Templates section.
        </p>
        <br />
        <p className="release-heading ">
          <Heading>3. Guide for all major Sections of SuperLemon</Heading>
        </p>
        <p>
          Guide is added for all the major sections of SuperLemon for ease of
          understanding of all features and their configurations. If you want to
          know more about the feature and functionality you can simply browse
          the guide for that section.
          <br />
          <br />
          You can open the guide by opening any section of SuperLemon and on the
          top right corner of the section, you will be able to see a ? icon as
          shown below: The <b>Automated</b> (only for Ultimate plan users)
          sub-section will have all Automated Message Templates i.e. Abandon
          Cart Template, Order Confirmation, Order Shipment and Cash on Delivery
          Template in a new sub-section of Automated Messages as shown below:
        </p>
        <img
          className="checkoutOptinModalImage"
          src="https://cdn.shopify.com/s/files/1/0449/7794/6790/files/r-3.png?v=1639474439"
          alt="Guide Overview"
        />
        <p>
          Clicking on this button will open a card highlighting the details of
          the section along with the <b>Start Guide</b> button. Clicking the “Start
          Guide” button will open up the guide in a new pop-up and you will be
          able to browse through all the different features and configurations
          available to you in that section.
        </p>
        <p className="release-heading ">
          <Heading>4. New Section of Admin Configuration</Heading>
        </p>
        <p>
          New Section of Admin Configuration is added so that you can configure
          all the generic settings of SuperLemon in one place.
          <br />
          <br />
          Admin Configuration now has the setting to add your WhatsApp number
          for Automated messages and Opt-in collection configuration.
          <br />
          <br />
          To know more about the Admin Configuration please go through the guide
          of the Admin Configuration section.
        </p>
      </TextContainer>
    );
  };

  const handleClose = () => {
    props.closeModal();
  };

  return (
    <Modal
      open={props.open}
      onClose={props.closeModal}
      title={"Release - 21.20.01"}
      secondaryActions={[
        {
          content: "Close",
          onAction: handleClose,
        },
      ]}
    >
      <Modal.Section>
        <Stack vertical>
          <Stack.Item>{modalContentGuideStep()}</Stack.Item>
        </Stack>
      </Modal.Section>
    </Modal>
  );
};
export default Release_21_20_01_Modal;
